module.exports = __webpack_public_path__ + "5124b16804cb385914ce506e1784a96a.png";